/* Royaume Peluche — barre d'annonce (bloc rp-announcement-bar) */
class RoyaumeAnnouncementBar {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-rp-ab-track]');
    this.group = el.querySelector('[data-rp-ab-group]');
    if (!this.track || !this.group) return;

    this.mode = el.dataset.mode || 'marquee';
    this.mobileMode = el.dataset.mobileMode || 'same';
    this.speed = parseFloat(el.dataset.speed) || 55;
    this.delay = (parseFloat(el.dataset.autoplay) || 5) * 1000;
    this.pauseOnHover = el.dataset.pauseOnHover === 'true';
    this.index = 0;
    this.timer = null;
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.items = Array.from(this.group.querySelectorAll('.rp-ab__item'));
    if (!this.items.length) return;

    el.classList.add('rp-ab--js');
    this.items[0].classList.add('is-active');

    this.initCountdowns();
    if (this.mode === 'marquee') this.initMarquee();
    if (this.needsRotation()) this.initRotation();

    window.addEventListener('resize', this.debounce(() => {
      if (this.mode === 'marquee') this.buildMarquee();
    }, 200));
  }

  debounce(fn, wait) {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); };
  }

  needsRotation() {
    if (this.items.length < 2) return false;
    if (this.mode === 'carousel' || this.mode === 'split') return true;
    return this.mode === 'marquee' && this.mobileMode === 'carousel';
  }

  /* Vrai quand rien ne doit tourner : split sur ordi, marquee en défilement */
  isStatic() {
    if (this.mode === 'split') return this.desktop.matches;
    if (this.mode === 'marquee') return this.desktop.matches || this.mobileMode !== 'carousel';
    return false;
  }

  /* ---------- Défilement continu ---------- */
  initMarquee() {
    if (this.reduced.matches) return;
    this.buildMarquee();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.buildMarquee());
    }
  }

  buildMarquee() {
    if (this.reduced.matches) return;
    this.track.querySelectorAll('.rp-ab__group--clone').forEach((n) => n.remove());

    if (this.mobileMode === 'carousel' && !this.desktop.matches) {
      this.track.style.animationDuration = '';
      return;
    }

    const groupWidth = this.group.getBoundingClientRect().width;
    if (!groupWidth) return;

    const copies = Math.max(1, Math.ceil((this.el.getBoundingClientRect().width * 2) / groupWidth));
    for (let i = 0; i < copies; i++) {
      const clone = this.group.cloneNode(true);
      clone.classList.add('rp-ab__group--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-rp-ab-group');
      clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      clone.querySelectorAll('[data-rp-countdown]').forEach((n) => n.removeAttribute('data-rp-countdown'));
      this.track.appendChild(clone);
    }

    this.track.style.setProperty('--rp-ab-shift', groupWidth + 'px');
    this.track.style.animationDuration = (groupWidth / this.speed).toFixed(2) + 's';
  }

  /* ---------- Rotation ---------- */
  initRotation() {
    if (this.pauseOnHover) {
      this.el.addEventListener('mouseenter', () => this.stop());
      this.el.addEventListener('mouseleave', () => this.start());
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { this.stop(); } else { this.start(); }
    });
    this.start();
  }

  goTo(i) {
    this.index = (i + this.items.length) % this.items.length;
    this.items.forEach((item, n) => item.classList.toggle('is-active', n === this.index));
  }

  start() {
    this.stop();
    if (this.reduced.matches) return;
    this.timer = setInterval(() => {
      if (this.isStatic()) return;
      this.goTo(this.index + 1);
    }, this.delay);
  }

  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }

  /* ---------- Compte à rebours ---------- */
  initCountdowns() {
    const nodes = this.el.querySelectorAll('[data-rp-countdown]');
    if (!nodes.length) return;
    const pad = (n) => String(n).padStart(2, '0');

    const target = (node) => {
      const now = new Date();
      if (node.dataset.type === 'date' && node.dataset.date) {
        const parts = node.dataset.date.split('-').map(Number);
        if (parts.length === 3 && !parts.some(isNaN)) {
          return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
        }
      }
      const hour = parseInt(node.dataset.hour, 10);
      const t = new Date(now);
      t.setHours(isNaN(hour) ? 14 : hour, 0, 0, 0);
      if (t <= now) t.setDate(t.getDate() + 1);
      return t;
    };

    const tick = () => {
      nodes.forEach((node) => {
        let diff = Math.floor((target(node) - new Date()) / 1000);
        if (diff < 0) diff = 0;
        const d = Math.floor(diff / 86400);
        const h = Math.floor((diff % 86400) / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const sec = diff % 60;
        node.textContent = d > 0
          ? d + 'j ' + pad(h) + ':' + pad(m) + ':' + pad(sec)
          : pad(h) + ':' + pad(m) + ':' + pad(sec);
      });
    };

    tick();
    setInterval(tick, 1000);
  }
}

function rpAnnouncementInit(scope) {
  (scope || document).querySelectorAll('[data-rp-ab]').forEach((el) => {
    if (el.dataset.rpAbReady === 'true') return;
    el.dataset.rpAbReady = 'true';
    new RoyaumeAnnouncementBar(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => rpAnnouncementInit());
} else {
  rpAnnouncementInit();
}

document.addEventListener('shopify:section:load', (e) => rpAnnouncementInit(e.target));
document.addEventListener('shopify:block:select', (e) => rpAnnouncementInit(e.target.closest('[data-rp-ab]') || document));
